import { defineComponent as t, openBlock as r, createBlock as l, unref as p, mergeProps as i, withCtx as s, createElementVNode as c } from "vue";
import { RevIcon as u } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconMinus",
  __name: "IconMinus",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const o = n;
    return (a, e) => (r(), l(p(u), i(o, { "view-box": "0 0 24 24" }), {
      default: s(() => [...e[0] || (e[0] = [
        c("path", {
          "fill-rule": "evenodd",
          d: "M5 12c0-.414.241-.75.538-.75h12.924C18.759 11.25 19 11.586 19 12s-.241.75-.538.75H5.538C5.241 12.75 5 12.414 5 12",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
